export default "__VITE_ASSET__rBOc0a1B__"